import * as Api from '@/helpers/restApi'

export default {
  state: {
    ChangeHistoryData: {},
    FirstColData: {},
    SecondColData: {}
  },
  getters: {
    getChangeHistoryData: state => state.ChangeHistoryData,
    getFirstColData: state => state.FirstColData,
    getSecondColData: state => state.SecondColData
  },
  mutations: {
    SetChangeHistoryData (state, val) {
      state.ChangeHistoryData = val
    },
    SetFirstColData (state, val) {
      state.FirstColData = val
    },
    SetSecondColData (state, val) {
      state.SecondColData = val
    }
  },
  actions: {
    setChangeHistory ({ commit, dispatch }, url) {
      // загружает данные для таблички в модалке "исторя изменений"
      Api.getApi({
        url
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetChangeHistoryData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setArticleActive ({ dispatch }, url) {
      // выбрать версию активной, то есть именно эта версия будет в редакторе
      // в payload null потому что беку так надо
      Api.putApi({
        url,
        // url: `/Articles/SetArticleActive/${id}`,
        payload: null
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setFirstColData ({ commit, dispatch }, url) {
      // загрузка данных для первой колонки
      Api.getApi({
        url
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetFirstColData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setSecondColData ({ commit, dispatch }, url) {
      // загрузка данных для второй колонки
      Api.getApi({
        url
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetSecondColData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
